Date.prototype.toJSON = function () {
    var timezoneOffsetInHours = -(this.getTimezoneOffset() / 60); //UTC minus local time
    var sign = timezoneOffsetInHours >= 0 ? '+' : '-';
    var leadingZero = (Math.abs(timezoneOffsetInHours) < 10) ? '0' : '';

    //It's a bit unfortunate that we need to construct a new Date instance 
    //(we don't want _this_ Date instance to be modified)
    var correctedDate = new Date(this.getFullYear(), this.getMonth(),
        this.getDate(), this.getHours(), this.getMinutes(), this.getSeconds(),
        this.getMilliseconds());
    correctedDate.setHours(this.getHours() + timezoneOffsetInHours);
    var iso = correctedDate.toISOString().replace('Z', '');

    return iso + sign + leadingZero + Math.abs(timezoneOffsetInHours).toString() + ':00';
}

import Vue from 'vue';
import App from './App.vue';

import router from './router'

import '@progress/kendo-ui';

import '@progress/kendo-theme-material/dist/all.css'

//import { DropDownList } from '@progress/kendo-vue-dropdowns';

import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { NumericTextBox } from '@progress/kendo-vue-inputs';

//Vue.component('dropdownlist', DropDownList);

Vue.component('kendo-multiselect', MultiSelect);
Vue.component('datepicker', DatePicker);
Vue.component('numerictextbox', NumericTextBox);

import { DropdownsInstaller } from '@progress/kendo-dropdowns-vue-wrapper';
/*Vue.use(AutoComplete);
Vue.use(ComboBox);*/
Vue.use(DropdownsInstaller);


import { Input } from '@progress/kendo-vue-inputs';
Vue.component('k-input', Input);

//import { Validator, ValidatorInstaller } from '@progress/kendo-validator-vue-wrapper'
//Vue.use(ValidatorInstaller);

//import Vuex from 'vuex'
//Vue.use(Vuex)

var VueCookie = require('vue-cookie');
Vue.use(VueCookie);

import VModal from 'vue-js-modal';
Vue.use(VModal);

//const appStore = new Vuex.Store({
//    state: {
//        appNum: '',
//        mode: '',
//        app: {}
//    },
//    mutations: {
//        saveAppNum(state, app) {
//            state.appNum = app
//        },
//         saveApp(state, app) {
//            state.app = app
//        },
//        saveMode(state, mode) {
//            state.mode = mode
//        }
//    },
//    actions: {
//        saveAppNum(context, app) {
//            context.commit('saveAppNum', app)
//        },
//         saveApp(context, app) {
//             context.commit('saveApp', app)
//        },
//        saveMode(context, mode) {
//            context.commit('saveMode', mode)
//        }
//    },
//});

Vue.config.productionTip = true;

Vue.prototype.$apiip = process.env.VUE_APP_ROOT_API
Vue.prototype.$rootip = process.env.VUE_APP_ROOT_IP


new Vue({
    components: {
      
    },
    router: router,
    //store: appStore,
    render: h => h(App)
}).$mount('#app');
